import { render, staticRenderFns } from "./zhexian.vue?vue&type=template&id=fbb2916e&scoped=true&"
import script from "./zhexian.vue?vue&type=script&lang=js&"
export * from "./zhexian.vue?vue&type=script&lang=js&"
import style0 from "./zhexian.vue?vue&type=style&index=0&id=fbb2916e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb2916e",
  null
  
)

export default component.exports